module.exports = __webpack_public_path__ + "img/ANTENNA RADIO GREEN.8406cb8.svg";